module.exports = __webpack_public_path__ + "static/media/goto_recetario.7def227b.svg";